var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "duplicate-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20453",
    "data-name": "Caminho 20453",
    className: "cls-1",
    d: "M3.625,23h9.75A2.629,2.629,0,0,0,16,20.375V7.625A2.629,2.629,0,0,0,13.375,5H3.625A2.629,2.629,0,0,0,1,7.625v12.75A2.629,2.629,0,0,0,3.625,23ZM3,7.625A.625.625,0,0,1,3.625,7h9.75A.625.625,0,0,1,14,7.625v12.75a.625.625,0,0,1-.625.625H3.625A.625.625,0,0,1,3,20.375Z",
    transform: "translate(-1 -1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20454",
    "data-name": "Caminho 20454",
    className: "cls-1",
    d: "M20.37,1H10.63A2.629,2.629,0,0,0,8.209,2.61a1,1,0,0,0,1.842.78A.63.63,0,0,1,10.63,3h9.74a.631.631,0,0,1,.63.63V16.37a.631.631,0,0,1-.63.63H18a1,1,0,0,0,0,2h2.37A2.633,2.633,0,0,0,23,16.37V3.63A2.633,2.633,0,0,0,20.37,1Z",
    transform: "translate(-1 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateIcon);
export default __webpack_public_path__ + "static/media/duplicate-icon.ae279b89d381f3769a9f298655d2fcbe.svg";
export { ForwardRef as ReactComponent };